import { Injectable } from '@angular/core';

@Injectable()
export class BuildResolvesService {

    constructor() {
    }

    static security(project: any, ProjectModel: any) {
        return ProjectModel.checkPermission(project, 'build');
    }

    static buildsTour(TourService: any, $transition$: any) {
        // When a state has children, you have to avoid
        // inheriting the tour setting.
        if ($transition$.to().name == 'home.project.summary.builds') {
            return TourService.setTour('buildBrowseCtrl');
        }
    }

    static getBuild(BuildService: any, params: any) {
        return BuildService.build(params.id);
    }

    static buildDetailTour(TourService: any) {
        return TourService.setTour('buildHomeCtrl');
    }
}
